import { ActionFunction } from 'react-router-dom'

import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const removeScoresAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const externalIds = formDataToArray(formData.get('scoreIds'))

  if (!externalIds.length) {
    return null
  }

  return http.action.post<RemoveScoresResponse>(ApiRoutes.members.removeScoresPath(), {
    score_ids: externalIds,
  })
}

export default removeScoresAction

export type RemoveScoresResponse = {
  failed: string[]
  scores: string[]
}
